import React from 'react';
import { AlertTriangle } from 'lucide-react';
import Modal from '../ui/Modal';
import Button from '../ui/Button';
import { useLanguage } from '../../lang/LangContext';
import { KEYS } from '../../lang/keys';

const CredentialWarningModal = ({ isOpen, onClose, onConfirm }) => {
    const { t } = useLanguage();
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={t(KEYS.CREDENTIAL_WARNING_TITLE)}
            size="small"
            footer={
                <>
                    <Button variant="outline" size="medium" onClick={onClose}>
                        {t(KEYS.COMMON_CANCEL)}
                    </Button>
                    <Button variant="primary" size="medium" onClick={onConfirm}>
                        {t(KEYS.CREDENTIAL_WARNING_CONFIRM)}
                    </Button>
                </>
            }
        >
            <div className="p-4">
                <div className="flex gap-3 p-3 rounded-md bg-status-overdue-bg border border-status-overdue/20">
                    <AlertTriangle className="w-5 h-5 text-status-overdue shrink-0 mt-0.5" />
                    <div className="space-y-1">
                        <p className="text-sm font-medium text-status-overdue">
                            Sensitive information
                        </p>
                        <p className="text-xs text-text-secondary">
                            Credentials contain sensitive information including usernames and passwords.
                            They will be visible for <span className="font-semibold text-text-primary">30 seconds</span> then automatically hidden.
                        </p>
                        <p className="text-xs text-text-muted">
                            Make sure no one else can see your screen before proceeding.
                        </p>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default CredentialWarningModal;
